import { SVGProps } from 'react'
// hey
import { IconProps } from '../core/icons'

export const ArpeggiLogo = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="mask0_1544_239116"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <g clipPath="url(#clip0_1544_239116)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.40921 0.000976562H-0.00256348V32.001H9.40921V18.8246H7.5266V0.00105574H9.40921V0.000976562Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.2981 0H20.7099V0.000211149H18.8293V18.8237H20.7099V32H11.2981V18.8237H13.1814V0.000211149H11.2981V0Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M31.9998 0H22.588V0.000211149H24.4735V18.8237H22.588V32H31.9998V0Z"
          fill="white"
        />
      </g>
    </mask>
    <g mask="url(#mask0_1544_239116)">
      <g filter="url(#filter0_f_1544_239116)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.38233 7.35616C15.9813 7.42141 30.0706 8.17978 33.5441 19.9306C36.967 31.5105 25.4774 40.1733 16.1619 47.2066C7.28225 53.9108 -3.28456 60.8261 -12.5428 54.7266C-23.6977 47.3777 -30.4025 32.6297 -25.7461 19.5971C-21.5293 7.79505 -7.50564 7.2893 4.38233 7.35616Z"
          fill="#E88D8D"
        />
      </g>
      <g filter="url(#filter1_f_1544_239116)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.5094 18.4669C21.6946 7.22402 21.2494 -6.47471 30.4143 -10.5675C39.4458 -14.6008 47.2527 -4.00398 53.5901 4.58701C59.6309 12.7761 50.3204 23.5713 46.1206 32.9195C41.0605 44.1828 11.9507 61.1875 1.15008 57.4821C-8.63083 54.1266 23.3446 29.9899 22.5094 18.4669Z"
          fill="#F6E08F"
        />
      </g>
      <g filter="url(#filter2_f_1544_239116)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1904 -25.0768C24.0782 -25.0167 40.9476 -24.3177 45.1064 -13.4864C49.2048 -2.81285 35.448 5.17206 24.2943 11.6549C13.6625 17.8344 1.01066 24.2085 -10.0745 18.5864C-23.4304 11.8126 -31.4583 -1.78123 -25.883 -13.7938C-20.8342 -24.6723 -4.04333 -25.1384 10.1904 -25.0768Z"
          fill="#A3DCD9"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_f_1544_239116"
        x="-41.7576"
        y="-7.16275"
        width="90.434"
        height="78.7581"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="7.25716" result="effect1_foregroundBlur_1544_239116" />
      </filter>
      <filter
        id="filter1_f_1544_239116"
        x="-13.685"
        y="-24.4241"
        width="82.2291"
        height="95.3971"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="6.48649" result="effect1_foregroundBlur_1544_239116" />
      </filter>
      <filter
        id="filter2_f_1544_239116"
        x="-41.2909"
        y="-38.6963"
        width="100.752"
        height="73.0683"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur stdDeviation="6.8076" result="effect1_foregroundBlur_1544_239116" />
      </filter>
      <clipPath id="clip0_1544_239116">
        <rect width="32" height="32" rx="2.50571" fill="white" />
      </clipPath>
    </defs>
  </svg>
)

export const HomeIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8 18V12H12V18H17V10H20L10 1L0 10H3V18H8Z" fill="currentColor" />
  </svg>
)

export const ExploreIcon = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.75 2.5C10.75 2.08579 10.4142 1.75 10 1.75C9.58578 1.75 9.25 2.08579 9.25 2.5L9.25 17.5C9.25 17.9142 9.58578 18.25 10 18.25C10.4142 18.25 10.75 17.9142 10.75 17.5L10.75 2.5ZM5.83333 5.08333C6.24754 5.08333 6.58333 5.41912 6.58333 5.83333L6.58333 14.1667C6.58333 14.5809 6.24754 14.9167 5.83333 14.9167C5.41912 14.9167 5.08333 14.5809 5.08333 14.1667L5.08333 5.83333C5.08333 5.41912 5.41912 5.08333 5.83333 5.08333ZM1.66666 8.41667C2.08088 8.41667 2.41666 8.75245 2.41666 9.16667L2.41666 10.8333C2.41666 11.2475 2.08088 11.5833 1.66666 11.5833C1.25245 11.5833 0.916662 11.2475 0.916663 10.8333L0.916663 9.16667C0.916663 8.75245 1.25245 8.41667 1.66666 8.41667ZM14.1667 5.08333C14.5809 5.08333 14.9167 5.41912 14.9167 5.83333L14.9167 14.1667C14.9167 14.5809 14.5809 14.9167 14.1667 14.9167C13.7525 14.9167 13.4167 14.5809 13.4167 14.1667L13.4167 5.83333C13.4167 5.41912 13.7525 5.08333 14.1667 5.08333ZM19.0833 9.16667C19.0833 8.75245 18.7475 8.41667 18.3333 8.41667C17.9191 8.41667 17.5833 8.75245 17.5833 9.16667L17.5833 10.8333C17.5833 11.2475 17.9191 11.5833 18.3333 11.5833C18.7475 11.5833 19.0833 11.2475 19.0833 10.8333L19.0833 9.16667Z"
      fill="currentColor"
    />
  </svg>
)

export const HeatIcon = (props) => (
  <svg
    width="14"
    height="21"
    viewBox="0 0 14 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.452 8.0397C10.8822 7.54775 10.3386 7.02079 9.88853 6.4082C7.32856 2.92431 8.65479 0 8.65479 0C3.90272 2.0841 2.82045 5.39218 2.76904 7.85573L2.77157 7.88187C2.77157 7.88187 2.8131 9.2939 3.41942 10.846C3.60921 11.3317 3.39762 11.8999 2.91546 12.0462C2.51683 12.1671 2.10719 11.962 1.93875 11.58C1.66611 10.9611 1.30604 9.97701 1.40954 9.28286C0.656811 10.3253 0.158816 11.5931 0.03099 12.9994C-0.305443 16.6973 2.13289 20.1293 5.61817 20.8556C9.61681 21.6889 13.3981 18.8219 13.9361 14.664C14.2727 12.0623 13.2561 9.59684 11.452 8.0397ZM9.06305 15.9784C9.03781 16.0134 8.39064 16.857 7.3063 16.9448C7.24755 16.9477 7.18582 16.9505 7.12707 16.9505C6.37893 16.9505 5.61977 16.5788 4.8659 15.8407L4.70066 15.6796L4.91088 15.5946C4.92488 15.5889 6.36493 15.0089 6.71812 13.7528C6.8386 13.3283 6.79936 12.845 6.60888 12.394C6.37916 11.8436 5.93647 10.4584 6.77709 9.45388L6.93957 9.26056L7.01806 9.50353C7.02081 9.51816 7.52799 11.0643 8.72731 11.8726C9.08875 12.1187 9.36047 12.4173 9.53144 12.7569C9.88394 13.4717 10.0914 14.6108 9.06305 15.9784Z"
      fill="#F96A4E"
    />
  </svg>
)

export const HeartIcon = (props) => (
  <svg
    width="18"
    height="17"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.65">
      <path
        d="M4.78099 0C3.54989 0 2.3207 0.487309 1.39207 1.46244C-0.465204 3.41267 -0.462842 6.53484 1.39207 8.48636L8.5074 15.9743C8.57044 16.0405 8.64626 16.0931 8.73025 16.1291C8.81425 16.1651 8.90468 16.1837 8.99605 16.1837C9.08743 16.1837 9.17786 16.1651 9.26186 16.1291C9.34585 16.0931 9.42167 16.0405 9.48471 15.9743C11.8591 13.4811 14.2326 10.9867 16.6071 8.49339C18.4643 6.54313 18.4643 3.41973 16.6071 1.46947C14.7498 -0.48078 11.6795 -0.480825 9.8222 1.46947L8.99957 2.33428L8.16991 1.46244C7.24126 0.487312 6.01209 0 4.78099 0ZM4.78099 1.32182C5.64808 1.32182 6.51349 1.67742 7.19262 2.39053L8.51444 3.77562C8.57748 3.84177 8.6533 3.89442 8.73729 3.9304C8.82129 3.96638 8.91171 3.98493 9.00309 3.98493C9.09446 3.98493 9.18489 3.96638 9.26888 3.9304C9.35287 3.89442 9.42869 3.84177 9.49173 3.77562L10.8065 2.39756C12.1648 0.971305 14.2715 0.971336 15.6298 2.39756C16.988 3.82378 16.988 6.13908 15.6298 7.56531C13.4188 9.88696 11.2105 12.2114 8.99957 14.533L2.36938 7.55828C1.01188 6.13008 1.01116 3.81671 2.36938 2.39053C3.04847 1.67742 3.9139 1.32182 4.78099 1.32182Z"
        fill="white"
      />
    </g>
  </svg>
)

export const ReverseIcon = (props) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.35372 1.68681C4.54898 1.49154 4.54898 1.17496 4.35372 0.979699C4.15845 0.784436 3.84187 0.784436 3.64661 0.979699L0.979943 3.64637C0.784681 3.84163 0.784681 4.15821 0.979943 4.35347L3.64661 7.02014C3.84187 7.2154 4.15845 7.2154 4.35372 7.02014C4.54898 6.82488 4.54898 6.50829 4.35372 6.31303L2.5406 4.49992H10.6668C10.943 4.49992 11.1668 4.27606 11.1668 3.99992C11.1668 3.72378 10.943 3.49992 10.6668 3.49992H2.5406L4.35372 1.68681ZM11.6466 9.68681C11.4513 9.49154 11.4513 9.17496 11.6466 8.9797C11.8419 8.78444 12.1585 8.78444 12.3537 8.9797L15.0204 11.6464C15.2156 11.8416 15.2156 12.1582 15.0204 12.3535L12.3537 15.0201C12.1585 15.2154 11.8419 15.2154 11.6466 15.0201C11.4513 14.8249 11.4513 14.5083 11.6466 14.313L13.4597 12.4999H5.3335C5.05735 12.4999 4.8335 12.2761 4.8335 11.9999C4.8335 11.7238 5.05735 11.4999 5.3335 11.4999H13.4597L11.6466 9.68681Z"
      fill="currentColor"
    />
  </svg>
)

export const DraftsIcon = (props) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.3334 10H13.3334L11.6667 12.5H8.33335L6.66669 10H1.66669M18.3334 10V15C18.3334 15.442 18.1578 15.866 17.8452 16.1785C17.5326 16.4911 17.1087 16.6667 16.6667 16.6667H3.33335C2.89133 16.6667 2.4674 16.4911 2.15484 16.1785C1.84228 15.866 1.66669 15.442 1.66669 15V10M18.3334 10L15.4584 4.25834C15.3204 3.98067 15.1077 3.74699 14.8442 3.58358C14.5806 3.42017 14.2768 3.33351 13.9667 3.33334H6.03335C5.72328 3.33351 5.41941 3.42017 5.15589 3.58358C4.89237 3.74699 4.67967 3.98067 4.54169 4.25834L1.66669 10"
      stroke="#F4F4F4"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const BugIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 0 24 24"
    width="24px"
    fill="#FFFFFF"
    {...props}
  >
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5s-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-4 4v3c0 .22-.03.47-.07.7l-.1.65-.37.65c-.72 1.24-2.04 2-3.46 2s-2.74-.77-3.46-2l-.37-.64-.1-.65C8.03 15.48 8 15.23 8 15v-4c0-.23.03-.48.07-.7l.1-.65.37-.65c.3-.52.72-.97 1.21-1.31l.57-.39.74-.18c.31-.08.63-.12.94-.12.32 0 .63.04.95.12l.68.16.61.42c.5.34.91.78 1.21 1.31l.38.65.1.65c.04.22.07.47.07.69v1zm-6 2h4v2h-4zm0-4h4v2h-4z" />
  </svg>
)

export const ProjectsIcon = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.98282 1.16667H10H10.0172H10.0174C10.8565 1.16667 11.5096 1.16667 12.0372 1.1997C12.5725 1.2332 13.0119 1.30206 13.4185 1.45509C14.6313 1.91157 15.5884 2.86873 16.0449 4.08155C16.098 4.22265 16.141 4.36771 16.1759 4.51935C17.6714 4.68933 18.8333 5.95898 18.8333 7.5V12.5C18.8333 14.041 17.6714 15.3107 16.1759 15.4807C16.141 15.6323 16.098 15.7774 16.0449 15.9185C15.5884 17.1313 14.6313 18.0884 13.4185 18.5449C13.0119 18.6979 12.5725 18.7668 12.0372 18.8003C11.5096 18.8333 10.8563 18.8333 10.0171 18.8333H10H9.98288C9.14366 18.8333 8.49041 18.8333 7.96275 18.8003C7.42751 18.7668 6.98814 18.6979 6.58154 18.5449C5.36872 18.0884 4.41156 17.1313 3.95509 15.9185C3.90198 15.7774 3.85901 15.6323 3.82413 15.4807C2.32858 15.3107 1.16666 14.041 1.16666 12.5V7.5C1.16666 5.95898 2.32858 4.68933 3.82413 4.51935C3.85901 4.36771 3.90198 4.22265 3.95509 4.08155C4.41156 2.86873 5.36872 1.91157 6.58154 1.45509C6.98814 1.30206 7.42751 1.2332 7.96275 1.1997C8.49036 1.16667 9.14352 1.16667 9.98261 1.16667H9.98282ZM16.3057 14.4439C17.1823 14.2316 17.8333 13.4418 17.8333 12.5V7.5C17.8333 6.55818 17.1823 5.7684 16.3057 5.55613C16.3333 6.06703 16.3333 6.69245 16.3333 7.48281V7.5V12.5V12.5172C16.3333 13.3076 16.3333 13.933 16.3057 14.4439ZM3.66666 12.5172C3.66666 13.3076 3.66666 13.933 3.69425 14.4439C2.81768 14.2316 2.16666 13.4418 2.16666 12.5V7.5C2.16666 6.55818 2.81768 5.7684 3.69425 5.55613C3.66666 6.06704 3.66666 6.69246 3.66666 7.48283V7.50001V12.5V12.5172ZM8.02522 2.19774C7.53644 2.22833 7.20837 2.28766 6.93379 2.391C5.99049 2.74603 5.24603 3.49049 4.89099 4.4338C4.78765 4.70837 4.72833 5.03645 4.69773 5.52522C4.66689 6.01799 4.66666 6.64003 4.66666 7.50001V12.5C4.66666 13.36 4.66689 13.982 4.69773 14.4748C4.72833 14.9636 4.78765 15.2916 4.89099 15.5662C5.24603 16.5095 5.99049 17.254 6.93379 17.609C7.20837 17.7124 7.53644 17.7717 8.02522 17.8023C8.51798 17.8331 9.14002 17.8333 10 17.8333C10.86 17.8333 11.482 17.8331 11.9748 17.8023C12.4636 17.7717 12.7916 17.7124 13.0662 17.609C14.0095 17.254 14.754 16.5095 15.109 15.5662C15.2123 15.2916 15.2717 14.9636 15.3023 14.4748C15.3331 13.982 15.3333 13.36 15.3333 12.5V7.5C15.3333 6.64003 15.3331 6.01799 15.3023 5.52522C15.2717 5.03645 15.2123 4.70837 15.109 4.4338C14.754 3.49049 14.0095 2.74603 13.0662 2.391C12.7916 2.28766 12.4636 2.22833 11.9748 2.19774C11.482 2.1669 10.86 2.16667 10 2.16667C9.14002 2.16667 8.51798 2.1669 8.02522 2.19774ZM9.16666 11.3333C8.52233 11.3333 8 11.8557 8 12.5C8 13.1443 8.52233 13.6667 9.16666 13.6667C9.811 13.6667 10.3333 13.1443 10.3333 12.5C10.3333 11.8557 9.811 11.3333 9.16666 11.3333ZM10.3333 10.6739C9.99656 10.4583 9.59621 10.3333 9.16666 10.3333C7.97005 10.3333 7 11.3034 7 12.5C7 13.6966 7.97005 14.6667 9.16666 14.6667C10.3633 14.6667 11.3333 13.6966 11.3333 12.5V6.7676L13.056 7.91603C13.2857 8.06921 13.5962 8.00712 13.7494 7.77736C13.9025 7.54759 13.8404 7.23716 13.6107 7.08398L11.1107 5.41731C10.9573 5.31503 10.76 5.30549 10.5974 5.3925C10.4348 5.47951 10.3333 5.64894 10.3333 5.83334V10.6739Z"
      fill="currentColor"
    />
  </svg>
)

export const GenesisStudioIcon = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1.16666C7.35942 1.16666 5.17547 2.26616 3.66771 3.34313C3.05697 3.77938 2.55209 4.21547 2.16666 4.58089V2.5C2.16666 2.22386 1.94281 2 1.66666 2C1.39052 2 1.16666 2.22386 1.16666 2.5V5.83333C1.16666 6.10947 1.39052 6.33333 1.66666 6.33333H4.58333C4.85947 6.33333 5.08333 6.10947 5.08333 5.83333C5.08333 5.55719 4.85947 5.33333 4.58333 5.33333H2.82656C3.1873 4.9892 3.66643 4.57295 4.24895 4.15686C5.65786 3.1505 7.64057 2.16666 10 2.16666C12.3864 2.16666 14.3362 2.95994 15.6881 4.31188C17.0401 5.66383 17.8333 7.61362 17.8333 10C17.8333 12.3864 17.0401 14.3362 15.6881 15.6881C14.3362 17.0401 12.3864 17.8333 10 17.8333C5.30896 17.8333 2.16666 13.9 2.16666 10C2.16666 9.72386 1.94281 9.5 1.66666 9.5C1.39052 9.5 1.16666 9.72386 1.16666 10C1.16666 14.3843 4.69103 18.8333 10 18.8333C12.6136 18.8333 14.8305 17.9599 16.3952 16.3952C17.9599 14.8305 18.8333 12.6136 18.8333 10C18.8333 7.38637 17.9599 5.1695 16.3952 3.60478C14.8305 2.04005 12.6136 1.16666 10 1.16666ZM10.5 6.66666C10.5 6.39052 10.2761 6.16666 10 6.16666C9.72386 6.16666 9.5 6.39052 9.5 6.66666V10C9.5 10.1672 9.58355 10.3233 9.72265 10.416L12.2226 12.0827C12.4524 12.2359 12.7628 12.1738 12.916 11.944C13.0692 11.7142 13.0071 11.4038 12.7773 11.2506L10.5 9.7324V6.66666Z"
      fill="currentColor"
    />
  </svg>
)

export const GenesisListenIcon = (props) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6648 2.84742C15.1773 2.72685 15.5298 2.64437 15.8041 2.60483C16.0746 2.56585 16.2118 2.57842 16.3046 2.60808C16.5359 2.68205 16.7324 2.8377 16.8574 3.04595C16.9075 3.12945 16.9512 3.26015 16.9752 3.53234C16.9995 3.80843 17 4.17047 17 4.69691V4.7928C17 5.50924 16.9905 5.71974 16.9219 5.88284C16.8531 6.04678 16.7417 6.18939 16.5994 6.29597C16.4578 6.40201 16.2559 6.46232 15.5608 6.63608L8 8.52628V5.92044C8 5.57378 8.00031 5.34039 8.01362 5.15788C8.02647 4.98166 8.04973 4.88693 8.07969 4.81645C8.14998 4.65107 8.26355 4.50768 8.40843 4.40138C8.47018 4.35607 8.55706 4.31173 8.72565 4.25886C8.90026 4.20411 9.12738 4.15035 9.46483 4.07095L14.6648 2.84742ZM15.8034 7.60622L8 9.55706V15.8333C8 17.4902 6.65685 18.8333 5 18.8333C3.34315 18.8333 2 17.4902 2 15.8333C2 14.1765 3.34315 12.8333 5 12.8333C5.76835 12.8333 6.46924 13.1222 7 13.5972V9.16667V5.92044V5.90262C6.99999 5.57831 6.99999 5.30832 7.01627 5.08515C7.0333 4.8516 7.0698 4.636 7.15937 4.42527C7.29996 4.09451 7.52709 3.80773 7.81686 3.59512C8.00148 3.45967 8.20299 3.37475 8.42642 3.30468C8.63994 3.23772 8.90275 3.17589 9.21844 3.10162L9.23579 3.09753L14.4358 1.874L14.4584 1.86869L14.4584 1.86869C14.9427 1.75471 15.3383 1.66164 15.6615 1.61506C15.9935 1.5672 16.306 1.55867 16.6091 1.65559C17.0718 1.80353 17.4648 2.11482 17.7148 2.53133C17.8786 2.80416 17.9419 3.11029 17.9713 3.4445C18 3.76977 18 4.17613 18 4.67373V4.69691V4.7928L18.0001 4.88934C18.0005 5.46428 18.0009 5.89651 17.8439 6.27018C17.7061 6.59806 17.4834 6.88327 17.1988 7.09644C16.8743 7.33937 16.4549 7.44386 15.897 7.58285L15.8034 7.60622ZM7 15.8333C7 14.7288 6.10457 13.8333 5 13.8333C3.89543 13.8333 3 14.7288 3 15.8333C3 16.9379 3.89543 17.8333 5 17.8333C6.10457 17.8333 7 16.9379 7 15.8333Z"
      fill="currentColor"
    />
  </svg>
)

export const PlusIcon = (props) => (
  <svg
    {...props}
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.7333 4.03314C11.7333 3.62813 11.405 3.2998 11 3.2998C10.595 3.2998 10.2667 3.62813 10.2667 4.03314V10.2665H4.03332C3.62832 10.2665 3.29999 10.5948 3.29999 10.9998C3.29999 11.4048 3.62832 11.7331 4.03332 11.7331H10.2667V17.9665C10.2667 18.3714 10.595 18.6998 11 18.6998C11.405 18.6998 11.7333 18.3714 11.7333 17.9665V11.7331H17.9667C18.3716 11.7331 18.7 11.4048 18.7 10.9998C18.7 10.5948 18.3716 10.2665 17.9667 10.2665H11.7333V4.03314Z"
      fill="currentColor"
    />
  </svg>
)

export const FeaturedIcon = (props) => (
  <svg
    {...props}
    width="18"
    height="26"
    viewBox="0 0 18 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.7241 9.95391C13.9914 9.34484 13.2924 8.69241 12.7138 7.93397C9.42243 3.62058 11.1276 0 11.1276 0C5.01779 2.58031 3.62629 6.67603 3.5602 9.72614L3.56344 9.75851C3.56344 9.75851 3.61685 11.5067 4.39639 13.4284C4.64041 14.0297 4.36836 14.7332 3.74844 14.9144C3.23593 15.0641 2.70925 14.8102 2.49267 14.3371C2.14214 13.5709 1.67919 12.3525 1.81227 11.4931C0.844471 12.7837 0.204192 14.3534 0.0398443 16.0945C-0.392713 20.6728 2.74229 24.922 7.22336 25.8213C12.3645 26.8529 17.2262 23.3033 17.9178 18.1554C18.3506 14.9343 17.0435 11.8818 14.7241 9.95391ZM11.6525 19.7828C11.62 19.8262 10.788 20.8706 9.39381 20.9793C9.31828 20.9828 9.23891 20.9864 9.16337 20.9864C8.20148 20.9864 7.22542 20.5261 6.25615 19.6123L6.04371 19.4128L6.31399 19.3077C6.33198 19.3005 8.18348 18.5825 8.63758 17.0273C8.79248 16.5017 8.74203 15.9033 8.49713 15.345C8.20178 14.6635 7.63261 12.9485 8.71341 11.7048L8.92231 11.4655L9.02322 11.7663C9.02676 11.7844 9.67884 13.6986 11.2208 14.6994C11.6855 15.0041 12.0349 15.3738 12.2547 15.7943C12.7079 16.6792 12.9747 18.0895 11.6525 19.7828Z"
      fill="currentColor"
    />
  </svg>
)

export const TrendUpIcon = (props) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.25 6C15.25 5.58579 15.5858 5.25 16 5.25H22C22.4142 5.25 22.75 5.58579 22.75 6V12C22.75 12.4142 22.4142 12.75 22 12.75C21.5858 12.75 21.25 12.4142 21.25 12V7.81066L15.5303 13.5303C15.5013 13.5593 15.4727 13.588 15.4445 13.6162C14.9844 14.0771 14.6282 14.4338 14.221 14.6356C13.4516 15.0169 12.5484 15.0169 11.779 14.6356C11.3718 14.4338 11.0156 14.0771 10.5555 13.6162C10.5273 13.588 10.4987 13.5593 10.4697 13.5303C9.88157 12.9422 9.71099 12.7857 9.55498 12.7084C9.20526 12.5351 8.79467 12.5351 8.44496 12.7084C8.28895 12.7857 8.11837 12.9422 7.53028 13.5303L2.53033 18.5303C2.23744 18.8232 1.76256 18.8232 1.46967 18.5303C1.17678 18.2374 1.17678 17.7625 1.46967 17.4696L6.46962 12.4697C6.49865 12.4406 6.52725 12.412 6.55546 12.3837C7.01555 11.9229 7.37172 11.5661 7.77895 11.3643C8.54832 10.9831 9.45162 10.9831 10.221 11.3643C10.6282 11.5661 10.9844 11.9229 11.4445 12.3837C11.4727 12.412 11.5013 12.4406 11.5303 12.4697C12.1184 13.0577 12.289 13.2143 12.445 13.2916C12.7947 13.4649 13.2053 13.4649 13.555 13.2916C13.711 13.2143 13.8816 13.0577 14.4697 12.4697L20.1893 6.75H16C15.5858 6.75 15.25 6.41421 15.25 6Z"
      fill="#22272F"
    />
  </svg>
)

export const WalletConnectLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="512px"
    height="512px"
    viewBox="0 0 512 512"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>logo</title>
    <desc>Created with Sketch.</desc>
    <defs>
      <radialGradient cx="0%" cy="50%" fx="0%" fy="50%" r="100%" id="radialGradient-1">
        <stop stopColor="#5D9DF6" offset="0%"></stop>
        <stop stopColor="#006FFF" offset="100%"></stop>
      </radialGradient>
    </defs>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="logo">
        <rect
          id="base"
          fill="url(#radialGradient-1)"
          x="0"
          y="0"
          width="512"
          height="512"
          rx="256"
        ></rect>
        <path
          d="M169.209772,184.531136 C217.142772,137.600733 294.857519,137.600733 342.790517,184.531136 L348.559331,190.179285 C350.955981,192.525805 350.955981,196.330266 348.559331,198.676787 L328.82537,217.99798 C327.627045,219.171241 325.684176,219.171241 324.485851,217.99798 L316.547278,210.225455 C283.10802,177.485633 228.89227,177.485633 195.453011,210.225455 L186.951456,218.549188 C185.75313,219.722448 183.810261,219.722448 182.611937,218.549188 L162.877976,199.227995 C160.481326,196.881474 160.481326,193.077013 162.877976,190.730493 L169.209772,184.531136 Z M383.602212,224.489406 L401.165475,241.685365 C403.562113,244.031874 403.562127,247.836312 401.165506,250.182837 L321.971538,327.721548 C319.574905,330.068086 315.689168,330.068112 313.292501,327.721609 C313.292491,327.721599 313.29248,327.721588 313.29247,327.721578 L257.08541,272.690097 C256.486248,272.103467 255.514813,272.103467 254.915651,272.690097 C254.915647,272.690101 254.915644,272.690105 254.91564,272.690108 L198.709777,327.721548 C196.313151,330.068092 192.427413,330.068131 190.030739,327.721634 C190.030725,327.72162 190.03071,327.721606 190.030695,327.721591 L110.834524,250.181849 C108.437875,247.835329 108.437875,244.030868 110.834524,241.684348 L128.397819,224.488418 C130.794468,222.141898 134.680206,222.141898 137.076856,224.488418 L193.284734,279.520668 C193.883897,280.107298 194.85533,280.107298 195.454493,279.520668 C195.454502,279.520659 195.45451,279.520651 195.454519,279.520644 L251.65958,224.488418 C254.056175,222.141844 257.941913,222.141756 260.338618,224.488222 C260.338651,224.488255 260.338684,224.488288 260.338717,224.488321 L316.546521,279.520644 C317.145683,280.107273 318.117118,280.107273 318.71628,279.520644 L374.923175,224.489406 C377.319825,222.142885 381.205562,222.142885 383.602212,224.489406 Z"
          id="WalletConnect"
          fill="#FFFFFF"
          fillRule="nonzero"
        ></path>
      </g>
    </g>
  </svg>
)

export const TwitterLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    version="1.1"
    id="Logo"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 248 204"
    // style="enable-background:new 0 0 248 204;"
    xmlSpace="preserve"
    {...props}
  >
    <g id="Logo_1_">
      <path
        id="white_background"
        style={{ fill: '#1D9BF0' }}
        d="M221.95,51.29c0.15,2.17,0.15,4.34,0.15,6.53c0,66.73-50.8,143.69-143.69,143.69v-0.04
		C50.97,201.51,24.1,193.65,1,178.83c3.99,0.48,8,0.72,12.02,0.73c22.74,0.02,44.83-7.61,62.72-21.66
		c-21.61-0.41-40.56-14.5-47.18-35.07c7.57,1.46,15.37,1.16,22.8-0.87C27.8,117.2,10.85,96.5,10.85,72.46c0-0.22,0-0.43,0-0.64
		c7.02,3.91,14.88,6.08,22.92,6.32C11.58,63.31,4.74,33.79,18.14,10.71c25.64,31.55,63.47,50.73,104.08,52.76
		c-4.07-17.54,1.49-35.92,14.61-48.25c20.34-19.12,52.33-18.14,71.45,2.19c11.31-2.23,22.15-6.38,32.07-12.26
		c-3.77,11.69-11.66,21.62-22.2,27.93c10.01-1.18,19.79-3.86,29-7.95C240.37,35.29,231.83,44.14,221.95,51.29z"
      />
    </g>
  </svg>
)

export const MetaMaskLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 318.6 318.6"
    // style="enable-background:new 0 0 318.6 318.6;"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <polygon
      style={{
        fill: '#E2761B',
        stroke: '#E2761B',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="274.1,35.5 174.6,109.4 193,65.8 "
    />
    <g>
      <polygon
        style={{
          fill: '#E4761B',
          stroke: '#E4761B',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="44.4,35.5 143.1,110.1 125.6,65.8 &#9;"
      />
      <polygon
        style={{
          fill: '#E4761B',
          stroke: '#E4761B',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="238.3,206.8 211.8,247.4 268.5,263 284.8,207.7 &#9;"
      />
      <polygon
        style={{
          fill: '#E4761B',
          stroke: '#E4761B',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="33.9,207.7 50.1,263 106.8,247.4 80.3,206.8 &#9;"
      />
      <polygon
        style={{
          fill: '#E4761B',
          stroke: '#E4761B',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="103.6,138.2 87.8,162.1 144.1,164.6 142.1,104.1 &#9;"
      />
      <polygon
        style={{
          fill: '#E4761B',
          stroke: '#E4761B',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="214.9,138.2 175.9,103.4 174.6,164.6 230.8,162.1 &#9;"
      />
      <polygon
        style={{
          fill: '#E4761B',
          stroke: '#E4761B',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="106.8,247.4 140.6,230.9 111.4,208.1 &#9;"
      />
      <polygon
        style={{
          fill: '#E4761B',
          stroke: '#E4761B',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="177.9,230.9 211.8,247.4 207.1,208.1 &#9;"
      />
    </g>
    <g>
      <polygon
        style={{
          fill: '#D7C1B3',
          stroke: '#D7C1B3',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="211.8,247.4 177.9,230.9 180.6,253 180.3,262.3 &#9;"
      />
      <polygon
        style={{
          fill: '#D7C1B3',
          stroke: '#D7C1B3',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="106.8,247.4 138.3,262.3 138.1,253 140.6,230.9 &#9;"
      />
    </g>
    <polygon
      style={{
        fill: '#233447',
        stroke: '#233447',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="138.8,193.5 110.6,185.2 130.5,176.1 "
    />
    <polygon
      style={{
        fill: '#233447',
        stroke: '#233447',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="179.7,193.5 188,176.1 208,185.2 "
    />
    <g>
      <polygon
        style={{
          fill: '#CD6116',
          stroke: '#CD6116',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="106.8,247.4 111.6,206.8 80.3,207.7 &#9;"
      />
      <polygon
        style={{
          fill: '#CD6116',
          stroke: '#CD6116',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="207,206.8 211.8,247.4 238.3,207.7 &#9;"
      />
      <polygon
        style={{
          fill: '#CD6116',
          stroke: '#CD6116',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="230.8,162.1 174.6,164.6 179.8,193.5 188.1,176.1 208.1,185.2 &#9;"
      />
      <polygon
        style={{
          fill: '#CD6116',
          stroke: '#CD6116',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="110.6,185.2 130.6,176.1 138.8,193.5 144.1,164.6 87.8,162.1 &#9;"
      />
    </g>
    <g>
      <polygon
        style={{
          fill: '#E4751F',
          stroke: '#E4751F',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="87.8,162.1 111.4,208.1 110.6,185.2 &#9;"
      />
      <polygon
        style={{
          fill: '#E4751F',
          stroke: '#E4751F',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="208.1,185.2 207.1,208.1 230.8,162.1 &#9;"
      />
      <polygon
        style={{
          fill: '#E4751F',
          stroke: '#E4751F',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="144.1,164.6 138.8,193.5 145.4,227.6 146.9,182.7 &#9;"
      />
      <polygon
        style={{
          fill: '#E4751F',
          stroke: '#E4751F',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="174.6,164.6 171.9,182.6 173.1,227.6 179.8,193.5 &#9;"
      />
    </g>
    <polygon
      style={{
        fill: '#F6851B',
        stroke: '#F6851B',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="179.8,193.5 173.1,227.6 177.9,230.9 207.1,208.1 208.1,185.2 "
    />
    <polygon
      style={{
        fill: '#F6851B',
        stroke: '#F6851B',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="110.6,185.2 111.4,208.1 140.6,230.9 145.4,227.6 138.8,193.5 "
    />
    <polygon
      style={{
        fill: '#C0AD9E',
        stroke: '#C0AD9E',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="180.3,262.3 180.6,253 178.1,250.8 140.4,250.8 138.1,253 138.3,262.3 106.8,247.4 117.8,256.4 &#10;&#9;140.1,271.9 178.4,271.9 200.8,256.4 211.8,247.4 "
    />
    <polygon
      style={{
        fill: '#161616',
        stroke: '#161616',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="177.9,230.9 173.1,227.6 145.4,227.6 140.6,230.9 138.1,253 140.4,250.8 178.1,250.8 180.6,253 "
    />
    <g>
      <polygon
        style={{
          fill: '#763D16',
          stroke: '#763D16',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="278.3,114.2 286.8,73.4 274.1,35.5 177.9,106.9 214.9,138.2 267.2,153.5 278.8,140 273.8,136.4 &#10;&#9;&#9;281.8,129.1 275.6,124.3 283.6,118.2 &#9;"
      />
      <polygon
        style={{
          fill: '#763D16',
          stroke: '#763D16',
          strokeLinecap: 'round',
          strokeLinejoin: 'round'
        }}
        points="31.8,73.4 40.3,114.2 34.9,118.2 42.9,124.3 36.8,129.1 44.8,136.4 39.8,140 51.3,153.5 103.6,138.2 &#10;&#9;&#9;140.6,106.9 44.4,35.5 &#9;"
      />
    </g>
    <polygon
      style={{
        fill: '#F6851B',
        stroke: '#F6851B',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="267.2,153.5 214.9,138.2 230.8,162.1 207.1,208.1 238.3,207.7 284.8,207.7 "
    />
    <polygon
      style={{
        fill: '#F6851B',
        stroke: '#F6851B',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="103.6,138.2 51.3,153.5 33.9,207.7 80.3,207.7 111.4,208.1 87.8,162.1 "
    />
    <polygon
      style={{
        fill: '#F6851B',
        stroke: '#F6851B',
        strokeLinecap: 'round',
        strokeLinejoin: 'round'
      }}
      points="174.6,164.6 177.9,106.9 193.1,65.8 125.6,65.8 140.6,106.9 144.1,164.6 145.3,182.8 145.4,227.6 &#10;&#9;173.1,227.6 173.3,182.8 "
    />
  </svg>
)

export const CoinbaseWalletLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="471.04 134.34 291.32 291.32" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g>
      <circle style={{ fill: '#3259A5' }} cx="616.7" cy="280" r="145.66" />
      <path
        style={{ fill: '#FFFFFF' }}
        d="M666.94,289.5c-4.45,23.58-25.14,41.41-50.01,41.41c-28.12,0-50.91-22.79-50.91-50.91s22.79-50.91,50.91-50.91 c24.87,0,45.56,17.84,50.01,41.41h51.37c-4.79-51.78-48.35-92.32-101.38-92.32c-56.24,0-101.82,45.59-101.82,101.82 c0,56.24,45.59,101.82,101.82,101.82c53.03,0,96.59-40.54,101.38-92.32H666.94z"
      />
    </g>
  </svg>
)

export const UploadProfileImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 101 98"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <ellipse cx="50.2183" cy="49" rx="48.0108" ry="47" fill="#C4C4C4" fillOpacity="0.3" />
    <rect x="0.163574" width="100.108" height="98" rx="49" fill="#C4C4C4" fillOpacity="0.3" />
    <path
      d="M65.3641 57.3366C65.3641 58.0192 65.0871 58.6738 64.5941 59.1565C64.101 59.6392 63.4323 59.9104 62.735 59.9104H39.0725C38.3752 59.9104 37.7065 59.6392 37.2134 59.1565C36.7204 58.6738 36.4434 58.0192 36.4434 57.3366V43.1806C36.4434 42.498 36.7204 41.8433 37.2134 41.3607C37.7065 40.878 38.3752 40.6068 39.0725 40.6068H44.3308L46.96 36.7461H54.8475L57.4766 40.6068H62.735C63.4323 40.6068 64.101 40.878 64.5941 41.3607C65.0871 41.8433 65.3641 42.498 65.3641 43.1806V57.3366Z"
      stroke="#101828"
      strokeWidth="0.685564"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M50.9037 54.7628C53.8078 54.7628 56.1621 52.4581 56.1621 49.6151C56.1621 46.7722 53.8078 44.4675 50.9037 44.4675C47.9997 44.4675 45.6454 46.7722 45.6454 49.6151C45.6454 52.4581 47.9997 54.7628 50.9037 54.7628Z"
      stroke="#101828"
      strokeWidth="0.685564"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const AddNewImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="44"
    height="37"
    viewBox="0 0 44 37"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M42.5553 31.6093C42.5553 32.605 42.1583 33.56 41.4518 34.2641C40.7452 34.9682 39.7869 35.3638 38.7876 35.3638H4.87852C3.87927 35.3638 2.92094 34.9682 2.21437 34.2641C1.50779 33.56 1.11084 32.605 1.11084 31.6093V10.9595C1.11084 9.96374 1.50779 9.00877 2.21437 8.30466C2.92094 7.60056 3.87927 7.205 4.87852 7.205H12.4139L16.1815 1.57324H27.4846L31.2523 7.205H38.7876C39.7869 7.205 40.7452 7.60056 41.4518 8.30466C42.1583 9.00877 42.5553 9.96374 42.5553 10.9595V31.6093Z"
      stroke="white"
      strokeWidth="1.78897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.8336 29.6615C26.9965 29.6615 31.1819 25.4907 31.1819 20.3459C31.1819 15.201 26.9965 11.0303 21.8336 11.0303C16.6707 11.0303 12.4854 15.201 12.4854 20.3459C12.4854 25.4907 16.6707 29.6615 21.8336 29.6615Z"
      stroke="white"
      strokeWidth="1.78897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9053 16.2236V24.6845"
      stroke="white"
      strokeWidth="1.78897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.7466 20.4541H26.0639"
      stroke="white"
      strokeWidth="1.78897"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
